
import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NadaConsta from "../../../components/nadaConsta";
import { Chip } from "primereact/chip";
import { formatarCNPJ, formatarCPF, formatarParaMoedaBRL } from "../../../utils";




export default function PendenciaLN({
  pendenciaLN
}: {
  pendenciaLN: any
}) {
  const { t } = useTranslation();
  const pendenciasCompleto = pendenciaLN.reports[0]
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {pendenciasCompleto.negativeData && pendenciasCompleto.negativeData.pefin && pendenciasCompleto.negativeData.pefin.pefinResponse && pendenciasCompleto.negativeData.pefin.pefinResponse.length > 0 ? (<span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('pendencias')}</span></span>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('pendencias')}</span>)}</div>;
  }
  const headerTemplateNegativao = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {pendenciasCompleto.negativeData && pendenciasCompleto.negativeData.refin && pendenciasCompleto.negativeData.refin.refinResponse && pendenciasCompleto.negativeData.refin.refinResponse.length > 0 ? (<span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('negativacoes')}</span></span>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('negativacoes')}</span>)}</div>;
  }
  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {pendenciasCompleto.negativeData && pendenciasCompleto.negativeData.notary && pendenciasCompleto.negativeData.notary.notaryResponse && pendenciasCompleto.negativeData.notary.notaryResponse.length > 0 ? (<span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('protestos')}</span></span>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('protestos')}</span>)}</div>;
  }
  return (
    <Panel header="Pendências">
      <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
                <label className="label-dados">{t('documento')}</label>
                 <Chip style={{width:"100%"}} label={pendenciasCompleto.registration.documentNumber ? formatarCPF(pendenciasCompleto.registration.documentNumber) : formatarCNPJ(pendenciasCompleto.registration.companyDocument)} />
            </div>
          </div>
          <div className="col">
          <div >
                <label className="label-dados">{t('nome')}</label>
                 <Chip style={{width:"100%"}} label={pendenciasCompleto.registration.consumerName ?? pendenciasCompleto.registration.companyName } />
            </div>
          </div>
      </div>
      {pendenciasCompleto.registration.documentNumber && (
        <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <div >
                  <label className="label-dados">{t('nomeMae')}</label>
                  <Chip style={{width:"100%"}} label={pendenciasCompleto.registration.motherName} />
              </div>
            </div>
            <div className="col">
            <div >
                  <label className="label-dados">{t('dataNascimento')}</label>
                  <Chip style={{width:"100%"}} label={pendenciasCompleto.registration.birthDate ? pendenciasCompleto.registration.birthDate.substring(8) + '/' + pendenciasCompleto.registration.birthDate.substring(5,7) + '/' + pendenciasCompleto.registration.birthDate.substring(0,4) : ''} />
              </div>
            </div>
        </div>
      ) }
    
      <br></br>
      <Panel headerTemplate={headerTemplate}>
        {!pendenciasCompleto.negativeData || !pendenciasCompleto.negativeData.pefin || !pendenciasCompleto.negativeData.pefin.pefinResponse || pendenciasCompleto.negativeData.pefin.pefinResponse.length === 0 ? ( <NadaConsta />) : (<>
        <DataTable size="small" value={pendenciasCompleto.negativeData.pefin.pefinResponse} tableStyle={{ minWidth: '50rem' }}>
            <Column body={(item)=> item.occurrenceDate.substring(8) + '/' + item.occurrenceDate.substring(5,7) + '/' + item.occurrenceDate.substring(0,4)} header={t('data')}></Column>
            <Column field="legalNature" header={t('natureza')}></Column>
            <Column field="contractId" header={t('contrato')}></Column>
            <Column field="creditorName" header={t('credor')}></Column>
            <Column body={(item)=>formatarParaMoedaBRL(item.amount)} header={t('valor')}></Column>
        </DataTable>
        </>)}
      </Panel>
      <br></br>
      <Panel headerTemplate={headerTemplateNegativao}>
        {!pendenciasCompleto.negativeData || !pendenciasCompleto.negativeData.refin || !pendenciasCompleto.negativeData.refin.refinResponse || pendenciasCompleto.negativeData.refin.refinResponse.length === 0 ? ( <NadaConsta />) : (<>
        <DataTable size="small" value={pendenciasCompleto.negativeData.refin.refinResponse} tableStyle={{ minWidth: '50rem' }}>
            <Column body={(item)=> item.occurrenceDate.substring(8) + '/' + item.occurrenceDate.substring(5,7) + '/' + item.occurrenceDate.substring(0,4)} header={t('data')}></Column>
            <Column field="legalNature" header={t('natureza')}></Column>
            <Column field="contractId" header={t('contrato')}></Column>
            <Column field="creditorName" header={t('credor')}></Column>
            <Column body={(item)=>formatarParaMoedaBRL(item.amount)} header={t('valor')}></Column>
        </DataTable>
        </>)}
      </Panel>
      <br></br>
      <Panel headerTemplate={headerTemplateProtesto}>
        {!pendenciasCompleto.negativeData || !pendenciasCompleto.negativeData.notary || !pendenciasCompleto.negativeData.notary.notaryResponse || pendenciasCompleto.negativeData.notary.notaryResponse.length === 0 ? ( <NadaConsta />) : (<>
        <DataTable size="small" value={pendenciasCompleto.negativeData.notary.notaryResponse} tableStyle={{ minWidth: '50rem' }}>
            <Column field="officeNumber" header={t('cartorio')}></Column>
            <Column body={(item)=> item.occurrenceDate.substring(8) + '/' + item.occurrenceDate.substring(5,7) + '/' + item.occurrenceDate.substring(0,4)} header={t('data')}></Column>
            <Column field="federalUnit" header={t('UF')}></Column>
            <Column field="city" header={t('cidade')}></Column>
            <Column body={(item)=>formatarParaMoedaBRL(item.amount)} header={t('valor')}></Column>
        </DataTable>
        </>)}
      </Panel>
    </Panel>
  )
}
